<template>

<div class="main list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="getList('main')" v-focus>
			<div class="button action input-go" @click="getList('main')"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters">
		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.internal_use_only ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('internal_use_only')"></span>
				<label>Hidden</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.inactive ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('inactive')"></span>
				<label>Inactive</label>
			</li>
			<li v-if="!getAdministratorFlag">
				<span :class="['pointer', 'far', filters.client ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('client')"></span>
				<label>Custom</label>
			</li>
		</ul>
		<div class="divider"></div>
		<div>
			<div class="button neutral" @click="clearFilters(1)">Clear Filters</div>
			<div class="button action" @click="addItem()">Add Caliber</div>
			<div :class="['button', gettingExport ? 'disabled' : 'neutral']" @click="doExport()">Export CSV</div>
			<div class="message">{{ exportMessage }}</div>
		</div>
	</div>

	<div class="list">
	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>
	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list left">Description</th>
					<th class="list center">Hidden</th>
					<th class="list center">Inactive</th>
					<th v-if="!getAdministratorFlag" class="list center">Custom</th>
				</tr>
			</thead>
			<tr v-for="(item, index) in list" class="clickable-list-item" @click="getItem(item)">
				<td class="list left">{{ item.description }}</td>
				<td class="list center"><i v-if="item.internal_use_only == 1" class="fas fa-check"></i></td>
				<td class="list center"><i v-if="item.inactive == 1" class="fas fa-check"></i></td>
				<td v-if="!getAdministratorFlag" class="list center"><i v-if="item.client_id == client_id" class="fas fa-check"></i></td>
			</tr>
		</table>

	</div>

	<iframe id="download" src="" style="display: none;"></iframe>

	<div v-if="showModal" class="modal">
		<div class="inner">
			<h2>{{ listDetail.caliber_id != 'new' ? 'Edit' : 'Add' }} A Caliber</h2>
			<div class="content">
				<label>Description</label>
				<input type="text" v-model="listDetail.description" :disabled="!userCanEdit"/>
				<label class="checkbox" style="margin: 0 1em 0 0;">
					<input type="checkbox" v-model="listDetail.internal_use_only" value="1" :disabled="!userCanEdit">
					<span :class="{ disabled: !userCanEdit }"><i class="fas fa-check-circle"></i>Hide Caliber</span>
				</label>
				<label class="checkbox">
					<input type="checkbox" v-model="listDetail.inactive" value="1" :disabled="!userCanEdit">
					<span :class="{ disabled: !userCanEdit }"><i class="fas fa-check-circle"></i>{{ listDetail.inactive == '1' ? 'Re' : 'De'}}activate Caliber</span>
				</label>
				<div v-if="userCanEdit && listDetail.caliber_id != 'new'" style="margin: 0.25em 0 0 0;">
					<label>Merge Into</label>
					<div class="input-with-control">
						<input type="search" ref="merge_search_term" v-model="filters.merge_search_term" placeholder="Search..." @search="getList('merge')" v-focus>
						<div class="button action input-go" @click="getList('merge')"><i class="fas fa-search"></i></div>
					</div>
					<ul v-if="mergeList.length > 0" class="modal-search-result clickable-list">
						<li v-for="(caliber, index) in mergeList" class="clickable-list-item" @click="setMerge(caliber)">{{ caliber.description }}</li>
					</ul>
				</div>
				<div class="message-overlay" v-if="modalMessage">
					<p>{{ modalMessage }}</p>
					<p v-if="modalSuccess"><i class="fa fa-check" /></p>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="backToList()">Cancel</div>
				<div :class="['button', 'spaced', !userCanEdit || !canSave || saving ? 'disabled' : 'action']" @click="saveItem()">Save Caliber</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<help-popup :helpLink="{163:'Calibers'}" :tours="false"></help-popup>

</div>

</template>

<script>
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'calibers',
    components: {
		'help-popup': HelpPopup
    },
	data() {
		return {
			client_id: '',
            loading: true,
			message: '',
			messageTimeout: 0,
			messageStatus: '',
			filters: {
				page: 1,
				search_term: '',
				merge_search_term: '',
				current_id: '',
				internal_use_only: 0,
				inactive: 0,
				client: 0,
				do_export: 0
			},
			list: [],
			mergeList: [],
			paging: {},
			showModal: false,
			gettingExport: false,
			listDetail: {},
			exportMessage: '',
			exporting: false,
			saving: false,
			modalMessage: '',
			modalSuccess: false
		}
	},
	created() {
		this.clearFilters(true)
	},
	computed: {
		canSave() {
			return this.listDetail.description
		},
		userCanEdit() {
			return this.listDetail.client_id == this.client_id || this.getAdministratorFlag
		}
	},
	methods: {
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				merge_search_term: '',
				current_id: '',
				internal_use_only: 0,
				inactive: 0,
				do_export: 0
			}
			if (getList) {
				this.getList('main')
			}
		},
		getList(context) {
			this.loading = true
			this.message = 'Loading list...'
			this.apiCall({ destination: 'get_list_calibers', data: this.filters }).then(obj => {
				this.client_id = obj.client_id
				this.loading = false
				this.messageStatus = obj.status
				this.message = obj.message
				//this.filters.page = 1
				if (this.filters.do_export) {
					this.filters.do_export = 0
					var outputFile = obj.file_name
					// accommodate live server filecache latency
					setTimeout(() => {
						document.getElementById("download").src = "//" + document.location.hostname + "/download.php?file_name=" + obj.file_name + "&output_file_name=" + outputFile
						this.exporting = false
						this.exportMessage = ''
					}, 1500)
				} else {
					if (context == 'merge') {
						this.mergeList = obj.calibers
					} else {
						this.list = obj.calibers
						if (obj.paging) {
							this.paging = obj.paging
						}
					}
				}
			}).catch(err => {
				//console.log(err)
				this.loading = false
				this.messageStatus = 'error'
				this.message = "There was an error loading the list."
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.getList()
		},
		getItem(item) {
			if (this.loading) { return }
			this.mergeList = []
			this.filters.merge_search_term = ''
			this.loading = true
			this.showModal = true
			this.apiCall({ destination: 'get_item_caliber', data: { caliber_id: item.caliber_id } }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.listDetail = obj.caliber
					this.filters.current_id = this.listDetail.caliber_id
				} else {
					this.modalMessage = obj.message
				}
			})
		},
		setMerge(caliber) {
			this.listDetail.merge_into = caliber.caliber_id
			this.filters.merge_search_term = caliber.description
			this.mergeList = []
		},
		addItem() {
			this.listDetail = {
				caliber_id: 'new',
				client_id: this.client_id,
				description: '',
				internal_use_only: 0,
				inactive: 0
			}
			this.userCanEdit = true
			this.showModal = true
		},
		saveItem() {
			if (this.saving) { return }
			this.saving = true
			this.modalSuccess = false
			this.modalMessage = ''
			this.apiCall({ destination: 'save_item_caliber', data: this.listDetail }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					if (this.listDetail.merge_into) {
						this.modalMessage = 'Caliber merged! (' + obj.merge_count + ' products affected)'
					} else {
						this.modalMessage = 'Caliber saved!'
					}
					this.modalSuccess = true
					setTimeout(() => {
						this.backToList()
						this.getList()
						this.modalMessage = ''
					}, 2000);
				} else {
					this.modalMessage = obj.message
					//this.modalMessage = "I couldn't save that for you. Maybe try something different — like ride a bike, or fly a kite."
					setTimeout(() => { this.modalMessage = '' }, 2000);
				}
			}).catch(err => {
				console.log(err)
			})
		},
		backToList() {
			this.showModal = false
			this.filters.merge_search_term = ''
			this.current_id = ''
			this.listDetail = {}
		},
		doExport() {
			if (this.exporting) { return }
			this.exporting = true
			this.exportMessage = 'Generating CSV for ' + this.list.length + ' items...'
			this.filters.do_export = true
			this.getList()
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
